import { Injectable } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';

@Injectable({
    providedIn: 'root',
})
export class UIService {
    constructor(
        private toastController: ToastController,
        private alertController: AlertController,
    ) {}

    async presentToast(position: 'top' | 'middle' | 'bottom', message: string) {
        const toast = await this.toastController.create({
            message: message,
            duration: 1500,
            position: position,
        });

        await toast.present();
    }

    async presentAlert(options: {
        header: string;
        message: string;
        buttons: any[];
        backdropDismiss?: boolean;
    }) {
        const alert = await this.alertController.create({
            header: options.header,
            message: options.message,
            buttons: options.buttons,
            backdropDismiss: options.backdropDismiss ?? true,
        });

        await alert.present();
        return alert;
    }
}
